// Returns true if the app is currently in "test" mode (test DB + test Stripe).
// Source of truth: sessionStorage override written by the AdminNav "Switch to
// Test DB / Switch to Live DB" toggle. Falls back to NODE_ENV when no override
// is set (dev defaults to test, prod defaults to live).
//
// Used by:
//   - Apollo client endpoint selection (/tgraphql vs /graphql)
//   - Stripe payment mutations (testBool passed to server to pick test vs live keys)
export const isTestMode = () => {
  const override =
    typeof window !== "undefined" && window.sessionStorage
      ? window.sessionStorage.getItem("bdr_gql_endpoint")
      : null;
  if (override === "/tgraphql") return true;
  if (override === "/graphql") return false;
  // No explicit override — infer from environment.
  // Localhost always defaults to test (covers both CRA dev server and
  // production builds served locally for testing).
  if (typeof window !== "undefined" && window.location) {
    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1" || host === "::1") {
      return true;
    }
  }
  return process.env.NODE_ENV === "development";
};

export const getGraphQLEndpoint = () => (isTestMode() ? "/tgraphql" : "/graphql");
